var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ProcessDiagramCard',{staticClass:"process-info-card",attrs:{"title":_vm.title,"description":_vm.description,"url":("" + _vm.publicPath + _vm.lastBpmnSrc)}}),_c('v-card',{attrs:{"elevation":"1"}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }